import { FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import Button from "../../../../ReusableComponent/Button";

const Step3Confirmation = () => {
  return (
    <section className="row mx-0 py-5 d-flex justify-content-center align-items-center">
      <div className="col-md-11 col-12">
        <div className="py-5 text-center">
          {/* Success Icon */}
          <FaCheckCircle size={80} className="text-success mb-4" />

          {/* Title */}
          <h2 className="fw-bold text-light mb-3">Registration Successful!</h2>
          <p className="text-muted mb-5">
            Thank you for registering for{" "}
            <span className="fw-semibold text-primary">
              International Coding Championship 2024
            </span>
            . You’ll receive a confirmation email shortly with event details.
          </p>

          {/* Action Buttons */}
          <div className="d-flex justify-content-center gap-3">
            <Button variant="back">
              <Link to="/Tournaments" className="btn btn-outline-light btn-lg">
                Back to Tournaments
              </Link>
            </Button>
            <Button variant="gradient">Download Receipt</Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Step3Confirmation;
